import { MapPin, Phone, Sparkles } from "lucide-react";
import { Logo } from "@/components/Logo";
import { PHONE_DISPLAY, PHONE_TEL } from "@/siteConfig";

const Footer = ({ onOpenStudio }) => (
    <footer
        data-testid="footer"
        className="border-t border-white/5 bg-[#0B0F17] pt-14 pb-28 md:pb-10"
    >
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-4 text-center sm:px-6">
            <div className="flex items-center gap-3">
                <Logo size={36} />
                <span className="font-display text-xl font-black text-white">المفتاح الذهبي</span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-gray-400">
                <a
                    href={PHONE_TEL}
                    data-testid="footer-phone-link"
                    className="flex items-center gap-2 transition-colors hover:text-amber-400"
                >
                    <Phone size={15} />
                    <span dir="ltr">{PHONE_DISPLAY}</span>
                </a>
                <span className="flex items-center gap-2" data-testid="footer-location">
                    <MapPin size={15} />
                    جدة، المملكة العربية السعودية — خدمة متنقلة
                </span>
                <span data-testid="footer-hours">مفتوح 24 ساعة · 7 أيام</span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-gray-400">
                <a href="#services" className="transition-colors hover:text-amber-400" data-testid="footer-link-services">الخدمات</a>
                <a href="#gallery" className="transition-colors hover:text-amber-400" data-testid="footer-link-gallery">أعمالنا</a>
                <a href="#faq" className="transition-colors hover:text-amber-400" data-testid="footer-link-faq">الأسئلة الشائعة</a>
                <a href="#location" className="transition-colors hover:text-amber-400" data-testid="footer-link-location">الموقع والأوقات</a>
            </div>
            <button
                onClick={onOpenStudio}
                data-testid="content-studio-open"
                className="flex items-center gap-2 rounded-full border border-amber-500/30 bg-amber-500/10 px-5 py-2.5 text-sm font-bold text-amber-400 transition-colors hover:bg-amber-500/20"
            >
                <Sparkles size={16} />
                مولّد المحتوى الذكي
            </button>
            <p className="text-xs text-gray-600">
                © {new Date().getFullYear()} المفتاح الذهبي — برمجة مفاتيح السيارات وفتح الأبواب المقفلة
            </p>
        </div>
    </footer>
);

export default Footer;
